import { atom } from "recoil"
const today = new Date()
export const createdAtState = atom<Date | string>({
  key: "atoms/matching/createdAtState",
  default: today,
})
